import { evaluationDataReducer } from 'src/modules/evaluation/reducers/evaluationDataReducer';
import { evaluationGenerateProposalReducer } from 'src/modules/evaluation/reducers/evaluationGenerateProposalReducer';
import { EvaluationState } from 'src/modules/evaluation/types/EvaluationState';
import { chainReducers } from 'src/utils/chainReducers';

const defaultState: EvaluationState = {
  generatedProposal: null,
};

export const evaluationReducer = chainReducers(defaultState, [
  evaluationDataReducer,
  evaluationGenerateProposalReducer,
]);
